import React, { useState, useRef, useEffect } from "react";
import { Button, Form, Input, Modal, Select, Upload } from "antd";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import globalRequest from "../../../../../utils/global/globalRequest";
import * as Validation from "../../../../../utils/helper/validation";
import * as Apis from "../../../../../utils/helper/enum";
import toast from "react-hot-toast";
import { changeLoader } from "../../../../../redux/reducers/loader";
import config from "../../../../../config";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

const PersonalDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const cropperRef = useRef(null);
  const [image, setImage] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [businessCategories, setBusinessCategories] = useState([]);

  let { id } = useParams();

  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
  };

  const handleUpload = ({ file }) => {
    const maxSize = 5 * 1024 * 1024; // 5 MB in bytes
    if (file.size > maxSize) {
      // Show an error message or notification
      toast.error("File size must be less than 5 MB.");
      return false; // Prevent adding the file to the file list
    }

    if (file.status === "removed") return false;

    const reader = new FileReader();
    reader.onload = () => setImage(reader.result);
    reader.readAsDataURL(file);
    setPreviewOpen(true);
    return false; // Prevent automatic upload
  };

  const handleCrop = () => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      const canvas = cropper.getCroppedCanvas({
        width: 500, // Reduce width (Adjust as needed)
        height: 500, // Reduce height
      });
      const croppedImage = canvas.toDataURL("image/jpeg", 0.7); // Lower quality to 70%
      setFileList([
        {
          uid: "-1",
          name: "image.png",
          status: "done",
          url: croppedImage,
        },
      ]);
      setPreviewOpen(false);
      setPreviewImage(croppedImage);
    }
  };

  const handleRemove = (file) => {
    setFileList([]);
    setPreviewImage("");
    setPreviewOpen(false);
  };

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <img src={previewImage ? previewImage : config.IMAGEBASEURL + `images/upload-img.png`} alt="Upload" />
    </button>
  );

  const handleSubmit = async (values) => {
    if (previewImage === "") {
      form.setFields([
        {
          name: "profile_image",
          errors: ["Please select your Profile picture."],
        },
      ]);
      return false;
    }
    values.profile_image = previewImage;
    values.businessCategoryId = form.getFieldValue("businessCategoryId");

    dispatch(changeLoader(true));
    try {
      let url = Apis?.MANAGE_QC?.CREATE_QC;
      let method = "post";
      if (id) {
        url = Apis?.MANAGE_QC?.EDIT_QC + "/" + id;
        method = "put";
      }
      let response = await globalRequest(url, method, values, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "QC created successfully";
        if (id) msg = "QC updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        navigate("/manage-QC");
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const getQcDetail = async (id) => {
    try {
      let response = await globalRequest(Apis.MANAGE_QC.GET_QC_DETAIL + "/" + id, "get", {}, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;
        form.setFieldValue("first_name", data?.firstName);
        form.setFieldValue("last_name", data?.lastName);
        form.setFieldValue("email", data?.email);
      const categories = Array.isArray(data?.qcDetail?.businessCategoryId)
        ? data.qcDetail.businessCategoryId
        : data?.qcDetail?.businessCategoryId
        ? data.qcDetail.businessCategoryId.split(",").map(Number)
        : [];
      form.setFieldValue("businessCategoryId", categories);
      let mobile = data?.mobileNo?.split("-");
        form.setFieldValue("mobile_no", mobile[1]);
        setPreviewImage(`https://rabbitholebucket.s3.eu-north-1.amazonaws.com/` + data?.qcDetail?.profileImage);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const getAllBusinessCategories = async () => {
    try {
      const response = await globalRequest(
        Apis.MANAGE_QC.GET_ALL_BUSINESS_CATEGORIES,
        "get",
        {},
        {},
        true
      );
      if (response?.status === 200) {
        const apiResponse = response?.data?.data || [];
        const categoryOptions = apiResponse.map((cat) => ({
          label: cat?.locales?.[0]?.name || "Unnamed Category",
          value: cat?.id,
        }));
        setBusinessCategories(categoryOptions);
      }
    } catch (error) {
      console.error("Error fetching business categories:", error.message);
    }
  };
  useEffect(() => {
    if (id) getQcDetail(id);
    getAllBusinessCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="min-h-[calc(100vh_-_305px)]">
        <Form
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          style={{
            maxWidth: 600,
            width: "100%",
          }}
          initialValues={{
            remember: true,
          }}
          autoComplete="off"
        >
          <Form.Item
            label="First Name"
            name="first_name"
            rules={[
              {
                required: true,
                message: "Please enter your Vendor First Name.",
              },
              {
                max: 30,
                message: "Maximum 30 characters",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "text");
                form.setFieldValue("first_name", value.trimStart());
                handleInputChange("first_name");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Last Name"
            name="last_name"
            rules={[
              {
                required: true,
                message: "Please enter your Vendor Last Name.",
              },
              {
                max: 30,
                message: "Maximum 30 characters",
              },
            ]}
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "text");
                form.setFieldValue("last_name", value.trimStart());
                handleInputChange("last_name");
              }}
            />
          </Form.Item>

          <Form.Item
            label="Mobile no"
            name="mobile_no"
            rules={[
              {
                required: true,
                message: "Please enter your Mobile No.",
              },
              {
                min: 9,
                message: "Mobile number must be 9 digits",
              },
              {
                max: 9,
                message: "Mobile number must be no more than 9 digits",
              },
            ]}
          >
            <Input
              size="large"
              placeholder="Mobile no"
              addonBefore={<span>+966</span>}
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "number");
                form.setFieldValue("mobile_no", value.trimStart());
                handleInputChange("mobile_no");
              }}
            />
          </Form.Item>
          <Form.Item
            label="E-mail ID"
            name="email"
            rules={[
              {
                required: true,
                message: "Please enter your email address.",
              },
              {
                pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                message: "Please enter a valid email address.",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              disabled={id ? true : false}
              size="large"
              onChange={(e) => {
                form.setFieldValue("email", e.target.value.trimStart());
                handleInputChange("email");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Profile picture"
            name="profile_image"
            rules={[
              {
                required: id ? false : true,
                message: "Please Select your Profile picture.",
              },
            ]}
          >
            <div className="mb-4 h-[102px]">
              <Upload
                listType="picture-card"
                fileList={fileList}
                beforeUpload={() => false}
                onChange={(e) => {
                  handleUpload(e);
                }}
                onRemove={handleRemove}
                showUploadList={{ showPreviewIcon: false }}
              >
                {fileList.length >= 1 ? null : uploadButton}
              </Upload>
            </div>
          </Form.Item>
          <Form.Item
            label="Business Category"
            name="businessCategoryId"
            // rules={[
            //   {
            //     required: true,
            //     message: "Please select at least one Business Category.",
            //   },
            // ]}
          >
            <Select
              mode="multiple"
              size="large"
              placeholder="Select business categories"
              options={businessCategories}
              onChange={(values) => form.setFieldValue("businessCategoryId", values)}
            />
          </Form.Item>
        </Form>
        <div className="flex justify-end gap-3">
          <Button onClick={() => navigate("/manage-QC")}>Cancel</Button>
          <Button type="primary" htmlType="submit" onClick={() => form.submit()}>
            Save
          </Button>
        </div>
      </div>

      <Modal
        open={previewOpen}
        onCancel={() => setPreviewOpen(false)}
        footer={[
          <Button key="back" onClick={() => setPreviewOpen(false)}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleCrop}>
            Crop and Upload
          </Button>,
        ]}
      >
        <Cropper src={image} style={{ height: 400, width: "100%" }} aspectRatio={1} guides={false} ref={cropperRef} />
      </Modal>
    </>
  );
};
export default PersonalDetails;
